/* ============== Social Icons ================ */
import instagram from '../assets/icons/instagram.svg'
import facebook from '../assets/icons/facebook.svg'
import twitter from '../assets/icons/twitter.svg'

export const SocialLinks = [
  {
    id: 1,
    title: 'icone do instagram',
    icon: instagram
  },
  {
    id: 2,
    title: 'icone do facebook',
    icon: facebook
  },
  {
    id: 3,
    title: 'icone do twitter',
    icon: twitter
  }
]
